// A mandatory "+", a country code starting 1-9, 7 to 15 digits in total (the E.164 ceiling), with
// spaces, dashes and parentheses tolerated and dropped. Generic shape only — a well-formed number
// that exists nowhere still reaches the server, which answers `unregistered_user`. The same rule the
// Customer Care search applies, copied rather than imported: a slice of `operations` imports nothing
// from `care`, and two callers are an observation, not a pattern.
const E164_PHONE = /^\+[\s()-]*[1-9][\s()-]*(?:\d[\s()-]*){6,14}$/;

export function parseE164Phone(input: string): string | null {
  const trimmed = input.trim();
  if (!E164_PHONE.test(trimmed)) return null;
  return `+${trimmed.replace(/\D/g, '')}`;
}
